import React from "react";

import LayoutWrapper from "../../../common/LayoutWrapper";
import YourWish from "../../../components/your_wishes/YOUR_WISH";
import WishSelectPlan from "../../../components/your_wishes/YOUR_WISH/WishSelectPlan";

import {
  customTab,
  nextTab,
  preTab,
  resetTab,
} from "../../../redux/slices/TabSlices";
import { connect } from "react-redux";

const YourWishPage = ({ currentTab, nextTab, preTab, resetCard }) => {
  const tabMaping = {
    1: <YourWish next={nextTab} pre={preTab} />,
    2: <WishSelectPlan next={nextTab} pre={preTab} />,
  };

  const renderTabs = () => {
    return tabMaping[currentTab];
  };
  return (
    <LayoutWrapper>
      <>{renderTabs()}</>
    </LayoutWrapper>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(YourWishPage);
